import React from "react";
import GlobalVariable from "../../../services/globalVar.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";

const SalesReturn = (props) => {
  const parentDatas = props;
  const currency = GlobalVariable.userDet.tenantConfig.currency;

  return (
    <div className="bg-white shadow-sm chart-of-account h-100 cc-greyCard-custm1">
          <div className="row coa-header kk-header-sec">
            <div className="col-auto header-right ms-auto"></div>
          </div>
    
          <div className="account-table">
            <DataTable
              stripedRows
              tableStyle={{ minWidth: "100%" }}
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="{first} to {last} of {totalRecords}"
              lazy
              value={parentDatas.salesReturn}
              expandedRows={parentDatas.expandedRows}
              onRowToggle={(e) => parentDatas.setExpandedRows(e.data)}
              rowExpansionTemplate={parentDatas.rowExpansionTemplateSalesReturn}
              emptyMessage="No data available"
            >
              <Column expander={parentDatas.allowExpansionSalesReturn} style={{ width: "4rem" }} />
    
              <Column
                field="invoiceNumber"
                header="Invoice Number "
              ></Column>
              <Column
                field="creditNoteNumber"
                header="Credit Note Number "
              ></Column>
              <Column
                field="invoiceDate"
                header=" Invoice Date "
                body={(row) => (
                    <div className="">
                         {format(
                    new Date(row.invoiceDate),
                    GlobalVariable.userDet.tenantConfig.dateFormat
                  )}
                    </div>
                )}
              ></Column>
              <Column
                field="customerName"
                header="Customer Name"
                body={(row) => row.firstName + " " + row.lastName}
              ></Column>
              <Column
                field="companyName"
                header=" Company Name"
              ></Column>
              <Column
                field="balancePayment"
                header="Balance Amount"
                className="text-end amount-align"
                body={(row) =>
                  currency + " " + row?.balancePayment?.toFixed(2)
                }
              ></Column>
              <Column
                field="totalAmount"
                header="Total Amount"
                className="text-end amount-align"
                body={(row) =>
                  currency + " " + row?.totalAmount?.toFixed(2)
                }
              ></Column>
              
            </DataTable>
          </div>
        </div>
  );
};

export default SalesReturn;
